// Helper: return true for a concrete analysis id (non-empty string, not the 'latest' sentinel)
export const isSpecificAnalysisId = (id?: unknown): id is string =>
  typeof id === 'string' && id !== 'latest' && id.trim().length > 0;
